<template>
  <div class="mx-auto mt-6">
    <div class="minHeightMainContent flex-col">
      <div v-if="!loading" class="w-3/4 md:w-1/2 lg:w-1/3">
        <UiSingleSelect
          v-model="className"
          title="RENAME_FEATURE_TO"
          :options="FEATURES_NAME.CLASSES"
          label="title"
          reduce="name"
          placeholder="CHANGE_CLASS_NAME"
          @change="renamClasses"
          @deSelect="deSelectClass"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
/* COMPONENTS */
import Loader from '@components/BaseComponent/Loader.vue'
import FEATURES_NAME from '@/src/constants/feature-name-constants.js'
/* 3rd party Component */
import { mapActions, mapState } from 'vuex'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'

export default {
  components: {
    Loader,
    UiSingleSelect,
  },
  page: {
    title: 'System Settings | Class Settings',
    meta: [
      {
        name: 'description',
        content: 'Class Settings',
      },
    ],
  },
  data: function () {
    return {
      FEATURES_NAME,
      settingsArray: [],
      tableHeadArray: ['Settings', 'View', 'Mark'],
      loading: false,
      excludeRoleSettings: ['campus_moderator', 'section_moderator', 'section_admin'],
      className: '',
    }
  },
  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'activeRole',
      'currentClassScope',
    ]),
    ...mapState('featureNaming', ['routerList']),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.setClassName()
      },
      deep: true,
    },
  },

  methods: {
    async renamClasses(value) {
      const payload = {
        original_name: 'CLASSES',
        custom_name: value ? value : 'CLASSES',
      }
      try {
        await this.setFeatureRename(payload)
      } catch (error) {
        this.className = ''
      }
    },
    deSelectClass() {
      let payload = { original_name: 'CLASSES', custom_name: 'CLASSES' }
      this.setFeatureRename(payload)
    },
    async setClassName() {
      const isUpper = !this.currentCampusScope
      const response = await this.fetchFeatureRename(isUpper)
      const features = response?.renamed_features || []
      const setClassName = features.find(
        (item) => item.original_name === 'CLASSES' && item.is_upper_level === isUpper,
      )
      if (setClassName) this.className = setClassName.custom_name
    },
    ...mapActions('featureNaming', ['setFeatureRename', 'fetchFeatureRename']),
    ...mapActions('settings', ['getClassSettings']),
  },
}
</script>
